module.exports = __webpack_public_path__ + "static/media/divisoriaKing.23c53def.png";